import React, { useState } from 'react';
import { 
  DollarSign,
  FileText,
  TrendingUp,
  TrendingDown,
  PieChart,
  BarChart3,
  Eye,
  Trash2,
  Edit,
  Save,
  X,
  Plus,
  Search,
  Filter,
  MoreHorizontal,
  Bookmark,
  Star,
  Share,
  Info,
  ExternalLink,
  Archive,
  Send,
  Flag,
  Heart,
  ThumbsUp,
  ThumbsDown,
  Upload,
  FileUp,
  FileDown,
  FileCheck,
  FileX,
  Volume2,
  VolumeX,
  Headphones,
  Speaker,
  Radio,
  Music,
  Video,
  Camera,
  Image,
  File,
  Folder,
  FolderOpen,
  HardDrive,
  Cloud,
  Wifi,
  WifiOff,
  Signal,
  Battery,
  BatteryLow,
  Power,
  PowerOff,
  Activity,
  Zap,
  Shield,
  Lock,
  Key,
  Users,
  Building,
  Calendar,
  Phone,
  Mail,
  MapPin,
  CheckSquare,
  Square as SquareIcon,
  ArrowUpRight,
  ArrowDownRight,
  ArrowLeft,
  Home,
  Wrench,
  FileBarChart,
  Cog,
  Settings,
  Link,
  Monitor,
  Tablet,
  Smartphone,
  Lightbulb,
  Cpu,
  Network,
  Database,
  Layers,
  User,
  Languages,
  Mic,
  Play,
  Pause,
  Square,
  RefreshCw,
  Copy,
  Download,
  Globe,
  Users2,
  AlertTriangle,
  CheckCircle,
  XCircle,
  Clock,
  Target,
  Brain,
  MessageSquare,
  AlertCircle,
  CheckSquare as CheckSquareIcon,
  Receipt,
  Bot,
  Scan,
  Zap as ZapIcon,
  Shield as ShieldIcon,
  LineChart,
  BarChart,
  PieChart as PieChartIcon,
  AreaChart,
  TrendingUp as TrendingUpIcon,
  TrendingDown as TrendingDownIcon,
  ArrowUp,
  ArrowDown,
  Minus,
  Percent,
  Calendar as CalendarIcon,
  Clock as ClockIcon,
  AlertCircle as AlertCircleIcon,
  Info as InfoIcon,
  Lightbulb as LightbulbIcon,
  Award,
  Gift,
  Coins,
  Wallet,
  PiggyBank,
  Banknote,
  Receipt as ReceiptIcon,
  ShoppingCart,
  Package,
  Truck,
  Building2,
  Factory,
  Store,
  Home as HomeIcon,
  Car,
  Plane,
  Train,
  Ship,
  Fuel,
  Wrench as WrenchIcon,
  Tool,
  Hammer,
  Screwdriver,
  Cog as CogIcon,
  Settings as SettingsIcon,
  BarChart as BarChartIcon,
  PieChart as PieChartIcon2,
  Activity as ActivityIcon,
  Zap as ZapIcon2,
  Target as TargetIcon,
  Brain as BrainIcon,
  Database as DatabaseIcon,
  Layers as LayersIcon,
  Network as NetworkIcon,
  Cpu as CpuIcon,
  Monitor as MonitorIcon,
  Smartphone as SmartphoneIcon,
  Tablet as TabletIcon,
  Globe as GlobeIcon,
  Users as UsersIcon,
  Building as BuildingIcon,
  Home as HomeIcon2,
  Car as CarIcon,
  Plane as PlaneIcon,
  Train as TrainIcon,
  Ship as ShipIcon,
  Truck as TruckIcon,
  Package as PackageIcon,
  ShoppingCart as ShoppingCartIcon,
  Receipt as ReceiptIcon2,
  Banknote as BanknoteIcon,
  PiggyBank as PiggyBankIcon,
  Wallet as WalletIcon,
  Coins as CoinsIcon,
  Gift as GiftIcon,
  Award as AwardIcon,
  Lightbulb as LightbulbIcon2,
  Info as InfoIcon2,
  AlertCircle as AlertCircleIcon2,
  Clock as ClockIcon2,
  Calendar as CalendarIcon2,
  Percent as PercentIcon,
  Minus as MinusIcon,
  ArrowDown as ArrowDownIcon,
  ArrowUp as ArrowUpIcon,
  TrendingDown as TrendingDownIcon2,
  TrendingUp as TrendingUpIcon2,
  AreaChart as AreaChartIcon,
  Shield as ShieldIcon2,
  Scan as ScanIcon,
  Bot as BotIcon,
  CheckSquare as CheckSquareIcon2,
  MessageSquare as MessageSquareIcon2,
  Brain as BrainIcon2,
  Target as TargetIcon2,
  Zap as ZapIcon3,
  Activity as ActivityIcon2,
  BarChart as BarChartIcon2,
  PieChart as PieChartIcon3,
  LineChart as LineChartIcon,
  TrendingDown as TrendingDownIcon3,
  TrendingUp as TrendingUpIcon3,
  Calculator as CalculatorIcon,
  CreditCard as CreditCardIcon,
  DollarSign as DollarSignIcon,
  FileText as FileTextIcon,
  Eye as EyeIcon,
  Trash2 as Trash2Icon,
  Edit as EditIcon,
  Save as SaveIcon,
  X as XIcon,
  Plus as PlusIcon,
  Search as SearchIcon,
  Filter as FilterIcon,
  MoreHorizontal as MoreHorizontalIcon,
  Bookmark as BookmarkIcon,
  Star as StarIcon,
  Share as ShareIcon,
  Info as InfoIcon3,
  ExternalLink as ExternalLinkIcon,
  Archive as ArchiveIcon,
  Send as SendIcon,
  Flag as FlagIcon,
  Heart as HeartIcon,
  ThumbsUp as ThumbsUpIcon,
  ThumbsDown as ThumbsDownIcon,
  Upload as UploadIcon,
  FileUp as FileUpIcon,
  FileDown as FileDownIcon,
  FileCheck as FileCheckIcon,
  FileX as FileXIcon,
  Volume2 as Volume2Icon,
  VolumeX as VolumeXIcon,
  Headphones as HeadphonesIcon,
  Speaker as SpeakerIcon,
  Radio as RadioIcon,
  Music as MusicIcon,
  Video as VideoIcon,
  Camera as CameraIcon,
  Image as ImageIcon,
  File as FileIcon,
  Folder as FolderIcon,
  FolderOpen as FolderOpenIcon,
  HardDrive as HardDriveIcon,
  Cloud as CloudIcon,
  Wifi as WifiIcon,
  WifiOff as WifiOffIcon,
  Signal as SignalIcon,
  Battery as BatteryIcon,
  BatteryLow as BatteryLowIcon,
  Power as PowerIcon,
  PowerOff as PowerOffIcon,
  Activity as ActivityIcon3,
  Zap as ZapIcon4,
  Shield as ShieldIcon3,
  Lock as LockIcon,
  Key as KeyIcon,
  Users as UsersIcon2,
  Building as BuildingIcon2,
  Calendar as CalendarIcon3,
  Phone as PhoneIcon,
  Mail as MailIcon,
  MapPin as MapPinIcon,
  CheckSquare as CheckSquareIcon3,
  Square as SquareIcon2,
  ArrowUpRight as ArrowUpRightIcon,
  ArrowDownRight as ArrowDownRightIcon,
  ArrowLeft as ArrowLeftIcon,
  Home as HomeIcon3,
  Wrench as WrenchIcon2,
  FileBarChart as FileBarChartIcon,
  Cog as CogIcon2,
  Settings as SettingsIcon2,
  Link as LinkIcon,
  Monitor as MonitorIcon2,
  Tablet as TabletIcon2,
  Smartphone as SmartphoneIcon2,
  Lightbulb as LightbulbIcon3,
  Cpu as CpuIcon2,
  Network as NetworkIcon2,
  Database as DatabaseIcon2,
  Layers as LayersIcon2,
  User as UserIcon,
  Languages as LanguagesIcon,
  Mic as MicIcon,
  Play as PlayIcon,
  Pause as PauseIcon,
  Square as SquareIcon3,
  RefreshCw as RefreshCwIcon,
  Copy as CopyIcon,
  Download as DownloadIcon,
  Globe as GlobeIcon2,
  Users2 as Users2Icon,
  AlertTriangle as AlertTriangleIcon,
  CheckCircle as CheckCircleIcon,
  XCircle as XCircleIcon,
  Clock as ClockIcon3,
  Target as TargetIcon3,
  Brain as BrainIcon3,
  MessageSquare as MessageSquareIcon3,
  AlertCircle as AlertCircleIcon3,
  CheckSquare as CheckSquareIcon4
} from 'lucide-react';
import DataTable from '../common/DataTable';
import ConfirmationModal from '../common/ConfirmationModal';

const ContractValueReports = () => {
  const [activeTab, setActiveTab] = useState('value-tracking');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [showGenerateModal, setShowGenerateModal] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  // Mock data for contract value tracking
  const [contractValueTracking, setContractValueTracking] = useState([
    {
      id: 'CV-001',
      contractName: 'IT Services Agreement - TechCorp',
      contractId: 'CONT-001',
      contractType: 'Service Agreement',
      category: 'IT Services',
      totalValue: '$180,000',
      remainingValue: '$165,000',
      utilizedValue: '$15,000',
      utilizationRate: 8.3,
      status: 'Active',
      startDate: '2023-01-15',
      endDate: '2024-12-31',
      renewalDate: '2024-12-31',
      vendor: 'TechCorp Solutions',
      department: 'IT',
      createdDate: '2023-01-10',
      lastUpdated: '2024-02-15',
      createdBy: 'Procurement Team',
      isActive: true,
      tags: ['it-services', 'active', 'high-value'],
      isBookmarked: true,
      isStarred: false,
      viewCount: 45,
      downloadCount: 8,
      aiInsights: ['Utilization below expected', 'Renewal decision pending', 'Performance metrics good'],
      keyMetrics: {
        monthlySpend: '$1,250',
        averageUtilization: '8.3%',
        costPerUser: '$45',
        slaCompliance: '98.5%'
      },
      riskFactors: ['Underutilization', 'Renewal timing', 'Vendor dependency'],
      performanceScore: 85.2
    },
    {
      id: 'CV-002',
      contractName: 'Software License - Microsoft',
      contractId: 'CONT-002',
      contractType: 'Software License',
      category: 'Software',
      totalValue: '$8,500',
      remainingValue: '$0',
      utilizedValue: '$8,500',
      utilizationRate: 100.0,
      status: 'Completed',
      startDate: '2023-01-01',
      endDate: '2023-12-31',
      renewalDate: '2024-01-01',
      vendor: 'Microsoft Corporation',
      department: 'IT',
      createdDate: '2022-12-15',
      lastUpdated: '2024-01-15',
      createdBy: 'Procurement Team',
      isActive: false,
      tags: ['software', 'completed', 'fully-utilized'],
      isBookmarked: false,
      isStarred: true,
      viewCount: 32,
      downloadCount: 5,
      aiInsights: ['Fully utilized contract', 'Renewal completed', 'Cost optimization achieved'],
      keyMetrics: {
        monthlySpend: '$708',
        averageUtilization: '100%',
        costPerUser: '$25',
        slaCompliance: '99.2%'
      },
      riskFactors: ['License compliance', 'Version updates', 'User growth'],
      performanceScore: 92.8
    },
    {
      id: 'CV-003',
      contractName: 'Cleaning Services - CleanPro',
      contractId: 'CONT-003',
      contractType: 'Service Agreement',
      category: 'Facilities',
      totalValue: '$26,400',
      remainingValue: '$24,200',
      utilizedValue: '$2,200',
      utilizationRate: 8.3,
      status: 'Active',
      startDate: '2023-06-01',
      endDate: '2024-05-31',
      renewalDate: '2024-05-31',
      vendor: 'CleanPro Services',
      department: 'Facilities',
      createdDate: '2023-05-15',
      lastUpdated: '2024-02-10',
      createdBy: 'Facilities Team',
      isActive: true,
      tags: ['cleaning', 'facilities', 'monthly-service'],
      isBookmarked: true,
      isStarred: false,
      viewCount: 28,
      downloadCount: 4,
      aiInsights: ['Consistent service delivery', 'Cost per square foot optimal', 'Satisfaction scores high'],
      keyMetrics: {
        monthlySpend: '$2,200',
        averageUtilization: '8.3%',
        costPerSqFt: '$0.15',
        satisfactionScore: '4.6/5.0'
      },
      riskFactors: ['Service quality', 'Price increases', 'Contractor availability'],
      performanceScore: 88.5
    }
  ]);

  // Mock data for liability analysis
  const [liabilityAnalysis, setLiabilityAnalysis] = useState([
    {
      id: 'LIAB-001',
      contractName: 'Cloud Infrastructure - AWS',
      contractId: 'CONT-004',
      contractType: 'Cloud Services',
      category: 'Technology',
      totalLiability: '$450,000',
      currentExposure: '$125,000',
      riskLevel: 'Medium',
      liabilityType: 'Data Breach',
      potentialImpact: '$2,500,000',
      mitigationStatus: 'In Progress',
      insuranceCoverage: '$1,000,000',
      lastAssessment: '2024-02-01',
      nextReview: '2024-05-01',
      createdBy: 'Risk Management',
      department: 'IT',
      isActive: true,
      tags: ['cloud', 'data-security', 'medium-risk'],
      isBookmarked: false,
      isStarred: true,
      viewCount: 67,
      downloadCount: 12,
      aiInsights: ['Data security protocols adequate', 'Insurance coverage sufficient', 'Regular audits recommended'],
      riskFactors: ['Data breach', 'Service outage', 'Compliance violations'],
      mitigationMeasures: ['Data encryption', 'Backup systems', 'Compliance monitoring'],
      exposureTrend: 'Stable'
    },
    {
      id: 'LIAB-002',
      contractName: 'Professional Services - Legal',
      contractId: 'CONT-005',
      contractType: 'Professional Services',
      category: 'Legal',
      totalLiability: '$75,000',
      currentExposure: '$25,000',
      riskLevel: 'Low',
      liabilityType: 'Professional Negligence',
      potentialImpact: '$500,000',
      mitigationStatus: 'Completed',
      insuranceCoverage: '$2,000,000',
      lastAssessment: '2024-01-15',
      nextReview: '2024-07-15',
      createdBy: 'Legal Team',
      department: 'Legal',
      isActive: true,
      tags: ['legal', 'professional-services', 'low-risk'],
      isBookmarked: true,
      isStarred: false,
      viewCount: 34,
      downloadCount: 6,
      aiInsights: ['Professional liability well managed', 'Insurance coverage adequate', 'Risk mitigation effective'],
      riskFactors: ['Professional errors', 'Client disputes', 'Regulatory changes'],
      mitigationMeasures: ['Quality controls', 'Professional standards', 'Regular reviews'],
      exposureTrend: 'Decreasing'
    }
  ]);

  // Calculate statistics
  const stats = {
    totalContracts: contractValueTracking.length,
    activeContracts: contractValueTracking.filter(c => c.status === 'Active').length,
    totalContractValue: contractValueTracking.reduce((sum, contract) => {
      const value = parseFloat(contract.totalValue.replace(/[$,]/g, ''));
      return sum + value;
    }, 0),
    totalRemainingValue: contractValueTracking.reduce((sum, contract) => {
      const value = parseFloat(contract.remainingValue.replace(/[$,]/g, ''));
      return sum + value;
    }, 0),
    averageUtilization: contractValueTracking.reduce((sum, contract) => sum + contract.utilizationRate, 0) / contractValueTracking.length,
    totalLiability: liabilityAnalysis.reduce((sum, liability) => {
      const value = parseFloat(liability.totalLiability.replace(/[$,]/g, ''));
      return sum + value;
    }, 0),
    highRiskLiabilities: liabilityAnalysis.filter(l => l.riskLevel === 'High').length,
    mediumRiskLiabilities: liabilityAnalysis.filter(l => l.riskLevel === 'Medium').length,
    lowRiskLiabilities: liabilityAnalysis.filter(l => l.riskLevel === 'Low').length
  };

  const tabs = [
    { id: 'value-tracking', label: 'Value Tracking' },
    { id: 'liability-analysis', label: 'Liability Analysis' },
    { id: 'performance', label: 'Performance Metrics' },
    { id: 'renewals', label: 'Renewal Management' }
  ];

  // Define columns for Contract Value Tracking DataTable
  const valueTrackingColumns = [
    {
      key: 'contractName',
      label: 'Contract & Value Details',
      width: '300px',
      render: (value, row) => (
        <div>
          <div style={{ fontWeight: '500', color: '#1f2937', marginBottom: '4px' }}>{value}</div>
          <div style={{ fontSize: '12px', color: '#6b7280' }}>
            {row.contractType} • {row.category} • {row.contractId}
          </div>
        </div>
      )
    },
    {
      key: 'totalValue',
      label: 'Total Value',
      width: '120px',
      render: (value) => (
        <span style={{ fontWeight: '600', color: '#1f2937' }}>{value}</span>
      )
    },
    {
      key: 'remainingValue',
      label: 'Remaining Value',
      width: '140px',
      render: (value) => (
        <span style={{ fontWeight: '600', color: '#007B8F' }}>{value}</span>
      )
    },
    {
      key: 'utilizationRate',
      label: 'Utilization',
      width: '120px',
      render: (rate) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <div style={{
            width: '60px',
            height: '6px',
            backgroundColor: '#e5e7eb',
            borderRadius: '3px',
            overflow: 'hidden'
          }}>
            <div style={{
              width: `${Math.min(rate, 100)}%`,
              height: '100%',
              backgroundColor: rate >= 80 ? '#10b981' : rate >= 50 ? '#f59e0b' : '#ef4444',
              transition: 'width 0.3s ease'
            }} />
          </div>
          <span style={{ 
            fontSize: '12px', 
            fontWeight: '500', 
            color: rate >= 80 ? '#10b981' : rate >= 50 ? '#f59e0b' : '#ef4444' 
          }}>
            {rate.toFixed(1)}%
          </span>
        </div>
      )
    },
    {
      key: 'status',
      label: 'Status',
      width: '100px',
      render: (status) => {
        const statusConfig = {
          'Active': { color: '#10b981', bg: '#d1fae5', icon: <CheckCircle size={14} /> },
          'Completed': { color: '#6b7280', bg: '#f3f4f6', icon: <CheckCircle size={14} /> },
          'Expired': { color: '#ef4444', bg: '#fee2e2', icon: <XCircle size={14} /> },
          'Pending': { color: '#f59e0b', bg: '#fef3c7', icon: <Clock size={14} /> }
        };
        const config = statusConfig[status] || statusConfig['Active'];
        
        return (
          <span style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            padding: '6px 10px',
            borderRadius: '6px',
            fontSize: '12px',
            fontWeight: '500',
            backgroundColor: config.bg,
            color: config.color,
            width: 'fit-content'
          }}>
            {config.icon}
            {status}
          </span>
        );
      }
    },
    {
      key: 'performanceScore',
      label: 'Performance',
      width: '120px',
      render: (score) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <div style={{
            width: '60px',
            height: '6px',
            backgroundColor: '#e5e7eb',
            borderRadius: '3px',
            overflow: 'hidden'
          }}>
            <div style={{
              width: `${score}%`,
              height: '100%',
              backgroundColor: score >= 90 ? '#10b981' : score >= 70 ? '#f59e0b' : '#ef4444',
              transition: 'width 0.3s ease'
            }} />
          </div>
          <span style={{ 
            fontSize: '12px', 
            fontWeight: '500', 
            color: score >= 90 ? '#10b981' : score >= 70 ? '#f59e0b' : '#ef4444' 
          }}>
            {score.toFixed(1)}
          </span>
        </div>
      )
    },
    {
      key: 'renewalDate',
      label: 'Renewal Date',
      width: '120px',
      render: (date) => new Date(date).toLocaleDateString()
    },
    {
      key: 'actions',
      label: 'Actions',
      width: '200px',
      render: (value, row) => (
        <div style={{ display: 'flex', gap: '6px' }}>
          <button
            onClick={() => handleView(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#007B8F',
              color: '#007B8F',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="View Details"
          >
            <Eye size={14} /> View
          </button>
          <button
            onClick={() => handleExport(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#10b981',
              color: '#10b981',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="Export Report"
          >
            <Download size={14} /> Export
          </button>
          <button
            onClick={() => handleDelete(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#ef4444',
              color: '#ef4444',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="Delete Contract"
          >
            <Trash2 size={14} /> Delete
          </button>
        </div>
      )
    }
  ];

  // Define columns for Liability Analysis DataTable
  const liabilityColumns = [
    {
      key: 'contractName',
      label: 'Contract & Liability Details',
      width: '300px',
      render: (value, row) => (
        <div>
          <div style={{ fontWeight: '500', color: '#1f2937', marginBottom: '4px' }}>{value}</div>
          <div style={{ fontSize: '12px', color: '#6b7280' }}>
            {row.contractType} • {row.category} • {row.contractId}
          </div>
        </div>
      )
    },
    {
      key: 'totalLiability',
      label: 'Total Liability',
      width: '120px',
      render: (liability) => (
        <span style={{ fontWeight: '600', color: '#1f2937' }}>{liability}</span>
      )
    },
    {
      key: 'currentExposure',
      label: 'Current Exposure',
      width: '140px',
      render: (exposure) => (
        <span style={{ fontWeight: '600', color: '#ef4444' }}>{exposure}</span>
      )
    },
    {
      key: 'riskLevel',
      label: 'Risk Level',
      width: '100px',
      render: (risk) => {
        const riskConfig = {
          'High': { color: '#ef4444', bg: '#fee2e2' },
          'Medium': { color: '#f59e0b', bg: '#fef3c7' },
          'Low': { color: '#10b981', bg: '#d1fae5' }
        };
        const config = riskConfig[risk] || riskConfig['Medium'];
        
        return (
          <span style={{
            padding: '4px 8px',
            borderRadius: '4px',
            fontSize: '12px',
            fontWeight: '500',
            backgroundColor: config.bg,
            color: config.color
          }}>
            {risk}
          </span>
        );
      }
    },
    {
      key: 'potentialImpact',
      label: 'Potential Impact',
      width: '140px',
      render: (impact) => (
        <span style={{ fontWeight: '500', color: '#ef4444' }}>{impact}</span>
      )
    },
    {
      key: 'mitigationStatus',
      label: 'Mitigation Status',
      width: '140px',
      render: (status) => {
        const statusConfig = {
          'Completed': { color: '#10b981', bg: '#d1fae5', icon: <CheckCircle size={14} /> },
          'In Progress': { color: '#f59e0b', bg: '#fef3c7', icon: <Clock size={14} /> },
          'Not Started': { color: '#ef4444', bg: '#fee2e2', icon: <XCircle size={14} /> }
        };
        const config = statusConfig[status] || statusConfig['Not Started'];
        
        return (
          <span style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            padding: '6px 10px',
            borderRadius: '6px',
            fontSize: '12px',
            fontWeight: '500',
            backgroundColor: config.bg,
            color: config.color,
            width: 'fit-content'
          }}>
            {config.icon}
            {status}
          </span>
        );
      }
    },
    {
      key: 'insuranceCoverage',
      label: 'Insurance Coverage',
      width: '140px',
      render: (coverage) => (
        <span style={{ fontWeight: '500', color: '#10b981' }}>{coverage}</span>
      )
    },
    {
      key: 'actions',
      label: 'Actions',
      width: '200px',
      render: (value, row) => (
        <div style={{ display: 'flex', gap: '6px' }}>
          <button
            onClick={() => handleView(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#007B8F',
              color: '#007B8F',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="View Details"
          >
            <Eye size={14} /> View
          </button>
          <button
            onClick={() => handleExport(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#10b981',
              color: '#10b981',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="Export Report"
          >
            <Download size={14} /> Export
          </button>
          <button
            onClick={() => handleDelete(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#ef4444',
              color: '#ef4444',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="Delete Analysis"
          >
            <Trash2 size={14} /> Delete
          </button>
        </div>
      )
    }
  ];

  // Handler functions
  const handleView = (item) => {
    //console.log('Viewing item:', item.contractName);
  };

  const handleExport = (contract) => {
    setSelectedItem(contract);
    setShowExportModal(true);
  };

  const handleDelete = (item) => {
    setSelectedItem(item);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    setIsDeleting(true);
    try {
      if (activeTab === 'value-tracking') {
        setContractValueTracking(prev => prev.filter(contract => contract.id !== selectedItem.id));
      } else {
        setLiabilityAnalysis(prev => prev.filter(liability => liability.id !== selectedItem.id));
      }
      setShowDeleteModal(false);
      setSelectedItem(null);
    } catch (error) {
      console.error('Error deleting item:', error);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleExportConfirm = async () => {
    setIsProcessing(true);
    try {
      setShowExportModal(false);
      setSelectedItem(null);
      // Here you would typically export the report
    } catch (error) {
      console.error('Error exporting report:', error);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div style={{
      padding: '24px',
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
      backgroundColor: '#f8fafc',
      minHeight: '100vh'
    }}>
      {/* Header */}
      <div style={{ marginBottom: '32px' }}>
        <h1 style={{
          fontSize: '32px',
          fontWeight: '700',
          color: '#1f2937',
          margin: '0 0 8px 0',
          background: 'linear-gradient(135deg, #007B8F 0%, #4A9BA8 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent'
        }}>
          Contract Value Reports
        </h1>
        <p style={{
          fontSize: '16px',
          color: '#6b7280',
          margin: 0
        }}>
          Comprehensive contract value tracking, liability analysis, and performance monitoring
        </p>
      </div>

      {/* Tabbed Navigation */}
      <div style={{ marginBottom: '32px' }}>
        <div style={{
          display: 'flex',
          borderBottom: '1px solid #e5e7eb',
          gap: '0'
        }}>
          {tabs.map(tab => (
            <button
              key={tab.id}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '12px 24px',
                color: activeTab === tab.id ? '#007B8F' : '#6b7280',
                borderBottom: activeTab === tab.id ? '3px solid #007B8F' : '3px solid transparent',
                transition: 'all 0.15s ease-in-out',
                fontWeight: '500',
                fontSize: '14px',
                backgroundColor: 'transparent',
                border: 'none',
                cursor: 'pointer',
                borderRadius: '6px 6px 0 0',
                fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
                position: 'relative',
                marginBottom: '-1px'
              }}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.id === 'value-tracking' && <DollarSign size={18} style={{ color: activeTab === tab.id ? '#007B8F' : '#9ca3af' }} />}
              {tab.id === 'liability-analysis' && <Shield size={18} style={{ color: activeTab === tab.id ? '#007B8F' : '#9ca3af' }} />}
              {tab.id === 'performance' && <BarChart3 size={18} style={{ color: activeTab === tab.id ? '#007B8F' : '#9ca3af' }} />}
              {tab.id === 'renewals' && <Calendar size={18} style={{ color: activeTab === tab.id ? '#007B8F' : '#9ca3af' }} />}
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Stats Cards */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '24px',
        marginBottom: '32px'
      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid #e5e7eb'
        }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 8px 0' }}>Total Contracts</p>
            <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1f2937', margin: 0 }}>{stats.totalContracts}</h2>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0 0' }}>
              {stats.activeContracts} active contracts
            </p>
          </div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: '#007B8F20',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#007B8F'
          }}>
            <FileText size={20} />
          </div>
        </div>

        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid #e5e7eb'
        }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 8px 0' }}>Total Contract Value</p>
            <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1f2937', margin: 0 }}>
              ${(stats.totalContractValue / 1000).toFixed(0)}K
            </h2>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0 0' }}>
              ${(stats.totalRemainingValue / 1000).toFixed(0)}K remaining
            </p>
          </div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: '#10b98120',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#10b981'
          }}>
            <DollarSign size={20} />
          </div>
        </div>

        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid #e5e7eb'
        }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 8px 0' }}>Avg. Utilization</p>
            <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1f2937', margin: 0 }}>
              {stats.averageUtilization.toFixed(1)}%
            </h2>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0 0' }}>
              Contract utilization rate
            </p>
          </div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: '#f59e0b20',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#f59e0b'
          }}>
            <TrendingUp size={20} />
          </div>
        </div>

        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid #e5e7eb'
        }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 8px 0' }}>Total Liability</p>
            <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1f2937', margin: 0 }}>
              ${(stats.totalLiability / 1000).toFixed(0)}K
            </h2>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0 0' }}>
              {stats.highRiskLiabilities} high, {stats.mediumRiskLiabilities} medium risk
            </p>
          </div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: '#ef444420',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#ef4444'
          }}>
            <Shield size={20} />
          </div>
        </div>
      </div>

      {/* Value Tracking Tab */}
      {activeTab === 'value-tracking' && (
        <div>
          {/* Value Tracking DataTable */}
          <div style={{ overflowX: 'auto', maxWidth: '100%' }}>
            <DataTable
              data={contractValueTracking}
              columns={valueTrackingColumns}
              title={`Contract Value Tracking (${contractValueTracking.length} contracts)`}
              searchable={false}
              sortable={true}
              exportable={true}
              pagination={true}
              pageSize={10}
              hiddenColumns={['none']}
              onHiddenColumnsChange={() => {}}
            />
          </div>
        </div>
      )}

      {/* Liability Analysis Tab */}
      {activeTab === 'liability-analysis' && (
        <div>
          {/* Liability Analysis DataTable */}
          <div style={{ overflowX: 'auto', maxWidth: '100%' }}>
            <DataTable
              data={liabilityAnalysis}
              columns={liabilityColumns}
              title={`Liability Analysis (${liabilityAnalysis.length} contracts)`}
              searchable={false}
              sortable={true}
              exportable={true}
              pagination={true}
              pageSize={10}
              hiddenColumns={['none']}
              onHiddenColumnsChange={() => {}}
            />
          </div>
        </div>
      )}

      {/* Other Tabs */}
      {activeTab === 'performance' && (
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
          border: '1px solid #e5e7eb',
          minHeight: '300px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '18px',
          color: '#6b7280'
        }}>
          Performance Metrics Dashboard Coming Soon!
        </div>
      )}

      {activeTab === 'renewals' && (
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
          border: '1px solid #e5e7eb',
          minHeight: '300px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '18px',
          color: '#6b7280'
        }}>
          Renewal Management Dashboard Coming Soon!
        </div>
      )}

      {/* Delete Confirmation Modal */}
      <ConfirmationModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleDeleteConfirm}
        title="Delete Contract"
        message={`Are you sure you want to delete "${selectedItem?.contractName}"? This action cannot be undone.`}
        confirmText="Delete"
        cancelText="Cancel"
        type="danger"
        isLoading={isDeleting}
      />

      {/* Export Report Modal */}
      <ConfirmationModal
        isOpen={showExportModal}
        onClose={() => setShowExportModal(false)}
        onConfirm={handleExportConfirm}
        title="Export Report"
        message={`Export contract value report for "${selectedItem?.contractName}"? This will generate a comprehensive report with value tracking and analysis.`}
        confirmText="Export"
        cancelText="Cancel"
        type="success"
        isLoading={isProcessing}
      />
    </div>
  );
};

export default ContractValueReports;
